import React from 'react';
import { Route, Redirect } from 'react-router-dom';

// Hooks
import { useCurrentUser } from 'Shared/utils/hooks/use-current-user';

type Props = {
  children: React.ReactNode;
};

function OnboardingPrivateRoute({ children, ...rest }: Props) {
  const { user: isLoggedIn } = useCurrentUser();
  return (
    <Route
      {...rest}
      render={({ location }) =>
        isLoggedIn ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: '/user/signup',
              state: { from: location },
            }}
          />
        )
      }
    />
  );
}

export default OnboardingPrivateRoute;
